<script setup lang="ts">
import { useRoute } from 'vue-router'
import EventEmailSettingsPanel from '@/components/organizer/events/EventEmailSettingsPanel.vue'

const route = useRoute()
const eventSlug = route.params['eventSlug'] as string
</script>

<template>
  <EventEmailSettingsPanel :event-slug="eventSlug" />
</template>
